import { sanitizeValue, stripHtmlTags } from "helpers";
import React from "react";

interface DisplayTextProps {
  value: string | number | undefined;
}

export const DisplayText: React.FC<DisplayTextProps> = ({ value }) => {
  value = sanitizeValue(value);
  value = stripHtmlTags(value);

  return <span>{value}</span>;
};
